import { AnyAction } from "redux";
import * as AT from "./actionTypes";
import { NavigationState } from "../../../../models/state";

const initialState: NavigationState = {
    navigating: false,
};

const reducer = (state = initialState, action: AnyAction): NavigationState => {
    switch (action.type) {
        case AT.NAVIGATION_START:
            return {
                ...state,
                navigating: true,
            };
        case AT.NAVIGATION_END:
            return {
                ...state,
                navigating: false,
            };
        default:
            return state;
    }
};

export default reducer;
